import axios from 'axios'
import {
  readStoredUserLocale,
  resolveDeviceLocale,
} from '../i18n/resolveDeviceLocale'

const usesNgrokBackend = String(
  import.meta.env.VITE_API_ENDPOINT ?? '',
).includes('ngrok')

const api = axios.create({
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  headers: {
    ...(usesNgrokBackend ? { 'ngrok-skip-browser-warning': '69420' } : {}),
    Accept: 'application/json',
    'Accept-Language': readStoredUserLocale() ?? resolveDeviceLocale(),
    'X-Requested-With': 'XMLHttpRequest',
  },
})

/** Compatibilidad: la sesión va por cookies; no hay Bearer. */
export const setAuthHeader = (_token?: string) => {
  delete api.defaults.headers.common['Authorization']
}

export const removeAuthHeader = () => {
  delete api.defaults.headers.common['Authorization']
}

export const setBaseUrl = (baseUrl: string) => {
  api.defaults.baseURL = baseUrl
}

export default api
